import { z } from 'zod'

export const AgreementTermTypes = ['rolling', 'fixed', 'oneOff', 'perpetual'] as const
export const AgreementTermTypeSchema = z.enum(AgreementTermTypes)

export type AgreementTermType = (typeof AgreementTermTypes)[number]

// A Record, so a new term type does not compile until someone decides whether its total is fixed.
const hasFixedTotalByTermType: Record<AgreementTermType, boolean> = {
  fixed: true,
  oneOff: true,
  rolling: false,
  perpetual: false,
}

export const hasFixedTotal = (type: AgreementTermType): boolean => hasFixedTotalByTermType[type]
